module.exports = __webpack_public_path__ + "static/espresso-z-cukrem@2x-3ca928ce3ad292fdfd156b2ee0b8fba5.png";